import appClient from './appClient'

export const getProducts = async (storeId) => {
    try {
        // Логирование входных данных
        console.log(`Fetching products for storeId: ${storeId}`);

        // Выполняем запрос
        const response = await appClient.get(`/product/by-store?storeId=${storeId}`);

        // Преобразуем все значения объекта в строки и форматируем expiration_date
        const products = response.data.map(product => {
            // Преобразование всех значений в строки
            const productWithFormattedDate = Object.fromEntries(
                Object.entries(product).map(([key, value]) => {
                    // Форматирование поля expiration_date
                    if (key === 'expiration_date' && value) {
                        const dateObj = new Date(value);
                        // Форматирование даты в нужный вид
                        const formattedDate = dateObj.toLocaleDateString('uk-UA', {
                            month: 'numeric',
                            day: 'numeric',
                        });
                        return [key, formattedDate];  // Возвращаем отформатированную дату
                    }
                    // Преобразование остальных значений в строки
                    return [key, String(value)];
                })
            );
            return productWithFormattedDate;
        });

        // Логирование успешного результата
        console.log(`Products fetched successfully:`, products);

        return products;  // Возвращаем преобразованные данные
    } catch (error) {
        // Логирование ошибок
        console.error(`Error fetching products for storeId ${storeId}:`, error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error(`Failed to fetch products for storeId ${storeId}`);
    }
};

export const getProductById = async (productId) => {
    try {
        // Логирование входных данных
        console.log('api getProductById productId:', productId);

        // Выполняем запрос
        const response = await appClient.get(`/product/by-id?productId=${productId}`);
        // Проверка на наличие данных в response
        if (!response.data) {
            throw new Error(`Product with ID ${productId} not found`);
        }

        // Преобразуем значения объекта в строки и форматируем expiration_date
        const product = Object.fromEntries(
            Object.entries(response.data).map(([key, value]) => {
                // Форматирование поля expiration_date
                if (key === 'expiration_date' && value) {
                    const dateObj = new Date(value);
                    // Форматирование даты в нужный вид
                    const formattedDate = dateObj.toLocaleDateString('uk-UA', {
                        month: 'numeric',
                        day: 'numeric',
                    });
                    return [key, formattedDate];  // Возвращаем отформатированную дату
                }
                // Преобразование остальных значений в строки
                return [key, String(value)];
            })
        );

        // Логирование успешного результата
        console.log('Product fetched successfully:', product);

        return product;  // Возвращаем преобразованный продукт
    } catch (error) {
        // Логирование ошибок
        console.error(`Error fetching product by ID ${productId}:`, error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error(`Failed to fetch product by ID ${productId}`);
    }
};

export const checkProductAvailability = async (cart) => {
    console.log('API checkProductAvailability cart:', cart);
    if (!cart || !cart.length) {
        console.log('API checkProductAvailability cart is empty');
        throw new Error('Cart is empty');
    }

    try {
        console.log('Validating product availability:', {cart});

        // Выполняем запрос к API
        const response = await appClient.post(`/product/check-availability`, { cart });

        // Логируем успешный результат
        console.info('Product availability validated:', response.data);

        // Если ответ содержит статус "success", возвращаем результат
        if (response.status === 200 && response.data.status === 'success') {
            // Все товары доступны
            return {available: true, unavailableProducts: []};
        }

        if (response.status === 206 && response.data.status === 'product_unavailable') {
            // Некоторые товары недоступны
            return {
                available: false,
                unavailableProducts: response.data.unavailable_products,
            };
        }

        throw new Error(response.data.message || 'Unknown error');
    } catch (error) {
        console.error('Error validating product availability:', error);
        throw new Error('Failed to validate product availability');
    }
};